import { FEATURE_GRID } from '@/content/features';
import FeatureCard from './FeatureCard';

/**
 * FeatureGrid Component
 * Displays the main 8 features in a responsive grid layout
 */
export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-24 bg-white dark:bg-secondary-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-900 dark:text-secondary-50 mb-4">
            Complete Clinical Documentation Workflow
          </h2>
          <p className="text-lg text-secondary-700 dark:text-secondary-300 max-w-3xl mx-auto">
            From consent capture to secure export, every feature is designed with clinical safety and compliance in mind.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {FEATURE_GRID.map((feature) => (
            <FeatureCard key={feature.id} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
}

